import React from "react";
import * as S from "./styles.ts";
import { InputProps } from "./types";

const Input: React.FC<InputProps> = ({
  label,
  error,
  register,
  format,
  onChange,
  ...rest
}) => {
  const applyMask = (value: string, mask: string) => {
    const cleanValue = value.replace(/[^\d]+/g, "");
    let maskedValue = "";

    let maskIndex = 0;
    for (let i = 0; i < cleanValue.length; i++) {
      if (maskIndex >= mask.length) break;

      const char = mask[maskIndex];
      if (char === "#") {
        maskedValue += cleanValue[i];
        maskIndex++;
      } else {
        maskedValue += char;
        maskIndex++;
        i--;
      }
    }

    return maskedValue;
  };

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const cleanValue = inputValue.replace(/[^\d]/g, "");
    const maskedValue = format ? applyMask(cleanValue, format) : inputValue;

    if (typeof register.onChange === "function") {
      register.onChange({ target: { value: cleanValue } });
    }

    e.target.value = maskedValue;
  };

  return (
    <S.StyledTextField
      {...register}
      {...rest}
      label={label}
      variant="outlined"
      error={!!error}
      helperText={error?.message}
      onChange={onChange ? onChange : onChangeHandler}
    />
  );
};

export default Input;
